module.exports = __webpack_public_path__ + "img/screening-acpt.0c4d6f9d.svg";